module.exports = __webpack_public_path__ + "img/header-engagementRingsPlatinum.c55bea9.jpg";